var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "margin" }, [
    _c("details", [
      _c(
        "summary",
        {
          on: {
            click: function ($event) {
              return _vm.toggleIcon()
            },
          },
        },
        [
          _c("i", {
            staticClass: "fa fa-fw aristotle-green",
            class: {
              "fa-chevron-down": _vm.isOpen,
              "fa-chevron-right": !_vm.isOpen,
            },
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { href: `#${_vm.content.name_plural}` },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.content.name_plural) +
                  " (" +
                  _vm._s(_vm.content.mapping.length) +
                  ")\n            "
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.content.mapping, function (metadataItem, metadataItemIndex) {
          return _c("li", { key: metadataItemIndex }, [
            metadataItem.name instanceof Object
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getElementHref(
                        metadataItem.name.name,
                        metadataItemIndex
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(metadataItem.name.name) +
                        "\n                "
                    ),
                  ]
                )
              : _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getElementHref(
                        metadataItem.name,
                        metadataItemIndex
                      ),
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(metadataItem.name) +
                        "\n                "
                    ),
                  ]
                ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }